import { Box, Grid, Stack, Typography } from '@mui/material';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { ReactElement } from 'react';
import { MCPMetrics } from './MCPGurardTrail';

interface MCPGuardDataSetProps {
  mcpMetrics: MCPMetrics | null;
}

const MCPGuardDataSet = ({
  mcpMetrics,
}: MCPGuardDataSetProps): ReactElement => {
  console.log(mcpMetrics);
  return (
    <Box className="approval-dataset-wrapper">
      <Grid container spacing={2} className="approval-array-set">
        <Grid item xs={12} sm={3}>
          <Box className="awaiting-approval-dataset">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" className="fw-6">
                Active Servers
              </Typography>

              <DnsOutlinedIcon sx={{ fontSize: 18, color: '#71717a' }} />
            </Stack>

            <Typography variant="h5" className="fw-7">
              {mcpMetrics?.activeServers ?? 0}
            </Typography>

            <Typography variant="body1">Total registered servers</Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Box className="awaiting-approval-dataset">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" className="fw-6">
                Active API Keys
              </Typography>

              <VpnKeyOutlinedIcon sx={{ fontSize: 18, color: '#71717a' }} />
            </Stack>

            <Typography variant="h5" className="fw-7">
              {mcpMetrics?.activeApiKeys ?? 0}
            </Typography>

            <Typography variant="body1">Total API keys</Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Box className="awaiting-approval-dataset">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" className="fw-6">
                Requests (24h)
              </Typography>

              <ShowChartOutlinedIcon sx={{ fontSize: 18, color: '#71717a' }} />
            </Stack>

            <Typography variant="h5" className="fw-7">
              {mcpMetrics?.requests ?? 0}
            </Typography>

            <Typography variant="body1">Total proxy requests</Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Box className="awaiting-approval-dataset">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body1" className="fw-6">
                Blocked (24h)
              </Typography>

              <ShieldOutlinedIcon sx={{ fontSize: 18, color: 'red' }} />
            </Stack>

            <Typography variant="h5" className="fw-7" sx={{ color: 'red' }}>
              {mcpMetrics?.blocked ?? 0}
            </Typography>

            <Typography variant="body1">Total blocked requests</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MCPGuardDataSet;
